import { ICreateSendSubmitState } from '../types/createSendSubmit';

export const DEFAULT_CREATE_SEND_SUBMIT_STATE: ICreateSendSubmitState = {
  isSubmitting: false,
  error: null,
  isCrmOpportunityPromptOpen: false,
};

export const EXPIRATION_OUTDATED_MESSAGE = 'Expiration date is outdated';

export const BULK_SEND_CREATED_MESSAGE = 'Bulk send created successfully';
